var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 33,
    rx: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 2,
    height: 25,
    rx: 1,
    transform: "rotate(-90 0 2)",
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 22,
    width: 2,
    height: 9,
    rx: 1,
    transform: "rotate(-90 3 22)",
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 27,
    width: 2,
    height: 9,
    rx: 1,
    transform: "rotate(-90 3 27)",
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 2,
    height: 19,
    rx: 1,
    transform: "rotate(-90 3 12)",
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 33,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(-90 0 33)",
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 2,
    height: 19,
    rx: 1,
    transform: "rotate(-90 3 7)",
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 2,
    height: 19,
    rx: 1,
    transform: "rotate(-90 3 17)",
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    width: 2,
    height: 12,
    rx: 1,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 24,
    r: 4.45,
    stroke: "currentColor",
    strokeWidth: 1.1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27.877,
    width: 1.365,
    height: 5.198,
    rx: 0.682,
    transform: "rotate(-40 20 27.877)",
    fill: "currentColor"
  })));
}
export default SvgAudits;